export default __webpack_public_path__ + "d5255e3e23d624a1274cd20a7433b0c0.svg";